import { alpha, styled } from '@mui/material/styles';
import { ListItem } from '@mui/material';

export const LeftIcon = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

export const NoPaddingList = styled('div')({
  paddingTop: 0,
  paddingBottom: 0,
});

export const HeaderRow = styled('div')(({ theme }) => ({
  borderTop: `2px solid ${alpha(theme.palette.action.disabledBackground, 0.05)}`,
  marginBottom: `-${theme.spacing(1)}`,
  marginTop: `${theme.spacing(1)}`,

  '& .div1': {
    marginLeft: '3%',
  },
  '& .div2': {
    marginLeft: 'auto',
    marginRight: theme.spacing(2),
  },
  '& .typeFilters': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
}));

export const ImageIcon = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: 2,
  right: 2,
  color: theme.palette.common.white,
}));

export const TopList = styled('div')(({ theme }) => ({
  borderColor: theme.palette.action.disabled,
  borderBottomWidth: 2,
}));

export const TopBar = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.action.disabledBackground,
  margin: '5px 10px 0 10px',
  height: 2,
}));

export const TaskRealmButton = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(1),
  marginLeft: theme.spacing(1),
}));

export const ExpandButton = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),

  '& span': {
    display: 'flex',
    alignItems: 'center',
    maxHeight: '21px',
    overflow: 'visible',
  },
}));

export const SubText = styled('div')({
  display: 'block',
  fontSize: 12,
});

export const TextRow = styled('div')({});

export const FlexRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',

  '& > div > .MuiTypography-root': {
    width: `calc(100% - ${theme.spacing(12)})`,
  },
}));

export const LeftIconWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  '& button': {
    padding: isMobile ? 0 : theme.spacing(1),
    marginRight: isMobile ? 5 : 0,
  },
}));

// Note: original applied both `ItemContainer` and `ItemContainerWithImage` via
// clsx; we collapse into a single styled `ListItem` driven by props.
export const ItemContainer = styled(ListItem, {
  shouldForwardProp: (prop) => !['readOnly', 'withImage'].includes(prop),
})(({ theme, readOnly, withImage }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderTop: readOnly ? 'none' : `2px solid ${alpha(theme.palette.action.disabledBackground, 0.05)}`,
  pointerEvents: readOnly ? 'none' : 'auto',
  cursor: readOnly ? 'default' : 'pointer',

  ...(readOnly ? {} : {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  }),

  ...(withImage ? { minHeight: 125 } : {}),

  '& .daterow': {
    fontSize: 12,
    marginLeft: 'auto',
    fontWeight: '400',
    fontStyle: 'italic',
  },

  '& .traderow': {
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: 12,
    marginLeft: 'auto',
    fontWeight: '400',
    '& span': {
      padding: '2px 8px',
      borderRadius: 12,
      marginBottom: '4px',
      marginRight: '4px',
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.text.primary,
    },
    '& span:first-child': {
      marginLeft: '-4px',
    },
  },

  '& .MuiListItemText-primary': {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },

  '& .MuiTypography-colorTextSecondary': {
    color: theme.palette.text.primary,
  },
}));

export const ExpandContainer = styled('div')({
  marginLeft: 48,
  width: '90%',
  display: 'flex',
  flexDirection: 'column',
});

export const Pad = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(1),
}));

export const TagContainer = styled('div')(({ theme }) => ({
  '& p': {
    marginBlock: `${theme.spacing(1)} !important`,
  },
}));

export const ImageRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  overflow: 'hidden',
  overflowX: 'auto',
});

export const PadRow = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const PadLeftRow = styled('div')(({ theme }) => ({
  paddingLeft: 56,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2),
  },
}));

export const SecondaryActionWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  height: `calc(100% - ${theme.spacing(2)})`,
}));
